import {Button, Image, Modal} from 'antd'
import {medal_getMedals_Api} from 'apis'
import {getId, getType} from 'apis/model/base'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useMemo, useState} from 'react'
import {useLocation} from 'react-router-dom'
import {branch, compose, fromRenderProps} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {MedalsSortBy} from 'views/AppLocals/factory/createEntitySortBy'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import CRUD from 'views/Shared/enums/CRUD'
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {RiSearchEyeLine} from "react-icons/ri";
import {BsGrid3X3GapFill, BsTable} from "react-icons/bs";
import {PiCertificate} from "react-icons/pi";
import getTitle from "helpers/getTitle";
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {LevelPill, MedalStatusBadge, MedalTagChips, medalGradient, renderMedalCardItem, renderMedalTableRow} from "../../Medal/renderMedal";
import MedalFilter from "../../Medal/MedalFilter";
import FetchMedalById from "../../Medal/FetchMedalById";
import WorkspaceContext from "../../WorkspaceContext";
import {useMedalManager} from "../../Medal/userMedalManager";
import {EntityPaginationMeta} from "../../../AppLocals/EntityList";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import LoadingBlock from "../../../Loading/LoadingBlock";
import PagePaginationWrapper from "../../../../modules/asyncCache/components/PagePagination/PagePaginationWrapper";
import EmptyHolder from "../../../../components/EmptyHolder";
import {renderLoading} from "../../../AppLocals/functions/renderers/renderLoading";
import classNames from "classnames";
import {HiViewfinderCircle} from "react-icons/hi2";


const renderGridMeta = (props) =>
    (
        <LayoutContext.Consumer>
            {({isLg}) => (
                <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                    <EntityPaginationMeta
                        {...props}
                        style={{position: 'inherit'}}
                    />
                </div>
            )}
        </LayoutContext.Consumer>
    )

// Key riêng cho "Xem chi tiết" - useMedalManager không có action READ nên xử lý cục bộ ở đây,
// không đụng hook dùng chung (WorkspaceMedalsList.js cũng xài).
const MEDAL_VIEW_DETAIL = 'medal-view-detail'

// Layout theo thẻ grid (renderMedalCardItem): ảnh lớn phía trên, thông tin phía dưới.
const DetailMedalModalContent = ({item}) => {
    const t = useTranslate()
    const {avatar, lvl_number, total_count, active, description} = item ?? {}
    const gradient = medalGradient(getId(item) || getTitle(item))

    return (
        <div className="flex flex-col gap-3">
            {/* Ảnh lớn phía trên */}
            <div className="w-full h-full relative">
                {avatar ? (
                    <Image
                        src={avatar}
                        style={{width: '100%', maxHeight: 400,  objectFit: 'cover'}}
                        wrapperStyle={{width: '100%', maxHeight: 400, display: 'block'}}
                        wrapperClassName="rounded-xl block"
                        className="rounded-xl"
                        preview={{
                            mask: (
                                <div className="w-full h-full relative">
                                    <HiViewfinderCircle
                                        size={16}
                                        style={{top: 10, right: 10}}
                                        className="absolute text-white opacity-85 hover:opacity-100 custom-img-view-icon"
                                    />
                                </div>
                            ),
                        }}
                    />
                ) : (
                    <div style={{background: gradient, height: 200}} className="flex flex-center">
                        <PiCertificate size={64} style={{color: 'rgba(255,255,255,0.85)'}}/>
                    </div>
                )}
            </div>

            {/* Thông tin phía dưới */}
            <div className="p-3 background-50 rounded-xl flex flex-col gap-3">
                <span className="font-bold text-lg text-color-000 leading-snug">
                    {getTitle(item)}
                </span>

                {description && (
                    <div className="pt-2.5 border-t border-color-50 flex flex-col gap-1">
                        <p className="text-xs text-color-300 tracking-wider whitespace-pre-line">
                            {description}
                        </p>
                    </div>
                )}

                <div className="flex flex-wrap items-center gap-1.5">
                    <LevelPill level={lvl_number} t={t}/>
                    <MedalStatusBadge active={active} t={t}/>
                </div>

                <MedalTagChips item={item}/>

                {total_count > 0 && (
                    <span className="text-xs text-color-300 whitespace-no-wrap">
                        {`${t('total_count')}: `}
                        <span className="font-bold text-color-100">{total_count}</span>
                    </span>
                )}
            </div>
        </div>
    )
}

const CourseMedals = ({
                          owner_id,
                          owner_type,
                          Wrapper = 'div',
                          filter_actions = {
                              sortBy: 'sort-by',
                              keyword: 'keyword',
                              active: 'active',
                          },
                      }) => {
    const t = useTranslate()
    const location = useLocation()

    const sortBy = useRouteSearchParam(filter_actions.sortBy)

    const active = useRouteSearchParam(filter_actions.active)

    // Bảng mặc định, chuyển sang Thẻ qua toggle - local state, không vào URL.
    const [viewMode, setViewMode] = useState('table')

    // Modal "Xem chi tiết" cục bộ (useMedalManager không có action READ, và hook dùng chung với
    // WorkspaceMedalsList.js nên không sửa hook).
    const [detailItem, setDetailItem] = useState(null)
    const onViewDetail = useCallback((item) => setDetailItem(item ?? null), [])

    const {
        refreshKey,
        modal = null,
        handleAction = NullAsDefault,
    } = useMedalManager({
        owner_id,
        owner_type,
    })

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiSearchEyeLine size={14} className="text-green-600"/>,
                        label: 'view detail',
                        key: MEDAL_VIEW_DETAIL,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: CRUD.UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: CRUD.DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    if (key === MEDAL_VIEW_DETAIL) {
                        onViewDetail(item)
                        return
                    }
                    handleAction(key, item)
                }
            ),
        [handleAction, onViewDetail]
    )

    // Cột: CHỨNG NHẬN | CẤP ĐỘ & TRẠNG THÁI | MÔ TẢ | THAO TÁC - khớp renderMedalTableRow.
    const TABLE_COLUMNS = [
        {label: t('certificates'), className: 'text-left'},
        {label: t('level'), className: 'text-left'},
        {label: t('status'), className: 'text-left'},
        {label: t('total_count'), className: 'text-left'},
        {label: t('actions'), className: 'text-right'},
    ]

    const renderList = useCallback(
        ({keyword, sortBy: currentSort, filterBy, refreshKey}) => (
            <PagePaginationWrapper
                apiInfo={medal_getMedals_Api}
                query={bindQueryParams([{id: owner_id}, {prop: owner_type}])}
                values={{keyword, sort_by: currentSort, ...(filterBy ?? {})}}
                refreshKey={refreshKey}
                renderItem={
                    viewMode === 'table'
                        ? renderMedalTableRow({translate: t, renderContextMenu, onView: onViewDetail})
                        : renderMedalCardItem({translate: t, renderContextMenu, onView: onViewDetail})
                }
                renderLoading={() => renderLoading()}
                renderEmpty={() => <EmptyHolder/>}
                Wrapper={({children}) => viewMode === 'table' ? (
                    <div className="mt-2 w-full overflow-x-auto rounded-xl border border-color-50">
                        <table className="w-full" style={{borderCollapse: 'collapse'}}>
                            <thead>
                                <tr className="background-200">
                                    {TABLE_COLUMNS.map((col, i) => (
                                        <th key={i} className={classNames("px-3 py-2 text-2xs font-bold text-color-400 uppercase tracking-wider whitespace-no-wrap", col.className)}>
                                            {col.label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>{children}</tbody>
                        </table>
                    </div>
                ) : (
                    <div className="mt-2 grid grid-cols-1 md:grid-cols-2 gap-4">
                        {children}
                    </div>
                )}
            />
        ),
        [owner_id, owner_type, t, renderContextMenu, onViewDetail, viewMode]
    )

    const viewModeToggle = (
        <div className="flex items-center flex-shrink-0 rounded-lg border border-color-200 overflow-hidden">
            <button
                type="button"
                title={t('table')}
                onClick={() => setViewMode('table')}
                style={{width: 40, height: 40}}
                className={classNames(
                    "flex flex-center transition-colors",
                    viewMode === 'table' ? 'bg-secondary-500 text-white' : 'background text-color-300 hover:text-secondary-600'
                )}>
                <BsTable size={14}/>
            </button>
            <button
                type="button"
                title={t('card')}
                onClick={() => setViewMode('card')}
                style={{width: 40, height: 40}}
                className={classNames(
                    "flex flex-center transition-colors border-l border-color-200",
                    viewMode === 'card' ? 'bg-secondary-500 text-white' : 'background text-color-300 hover:text-secondary-600'
                )}>
                <BsGrid3X3GapFill size={14}/>
            </button>
        </div>
    )

    const [pager_widget] = usePaginationHelper({
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onSortChange(sortBy)
            onFilterChange({
                active,
            })
        },
        renderList,
        // Toggle Bảng/Thẻ đặt giữa ô search và nút Lọc - không đụng MedalFilter / search bar /
        // MedalsSortBy (vẫn ẩn qua sortHeader: null).
        renderHeader: ([search_bar]) => (
            <div className="flex items-center gap-2">
                <div className="flex-1 min-w-0">{search_bar}</div>
                {viewModeToggle}
            </div>
        ),
        sortHeader: null,
        SortByWidget: MedalsSortBy,
        AdvancedFilter: MedalFilter,
        query_params: filter_actions,
        dependencies: [owner_id, owner_type],
        withKey: createPagerKey(refresh_deps),
        filter_params: [active],
    })

    return (
        <Wrapper className="flex flex-col gap-3">
            <div className="flex flex-col md:flex-row md:items-center gap-x-6 gap-y-3">
                <div className="flex flex-col flex-1">
                    <h2 className="font-bold text-xl text-gray-800 tracking-wide">
                        {t('course certificates')}
                    </h2>
                    <div className="my-1 w-20 h-1 rounded-full bg-gray-400"/>
                    <div className="mt-1 text-sm text-color-300 tracking-wider">
                        {t('course certificates description')}
                    </div>
                </div>
                <Button
                    color="primary" variant="solid"
                    className="px-6 py-2 font-semibold rounded-lg"
                    onClick={() => {
                        handleAction(CRUD.CREATE)
                    }}>
                    {t('create certificates')}
                </Button>
            </div>
            {pager_widget}
            {modal}
            <Modal
                open={!!detailItem}
                onCancel={() => setDetailItem(null)}
                footer={null}
                destroyOnHidden={true}
                width={600}
                className="custom-modal"
                title={
                    <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                        {t('view detail')}
                    </div>
                }>
                {detailItem && (
                    <FetchMedalById id={getId(detailItem)}>
                        {({isLoading, item}) => {
                            if (isLoading) return <LoadingBlock/>
                            return <DetailMedalModalContent item={item || detailItem}/>
                        }}
                    </FetchMedalById>
                )}
            </Modal>
            <div className="h-16"/>
        </Wrapper>
    )
}

export default compose(
    fromRenderProps(WorkspaceContext.Consumer, ({organization}) => ({
        owner_id: getId(organization),
        owner_type: getType(organization),
    })),
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], (e) => !e),
        () => () => <ContentNotFound/>
    )
)(CourseMedals)
